module.exports = __webpack_public_path__ + "static/media/_MIC2707.image.963fd022.png";